import React from 'react'

import BrandsSelectorModal from  './modal'

import {
    Button,
    Row
} from 'antd'

class BrandsSelector extends React.Component {

    state = {
        visible: false,
        renderModal: false
    }

    render(){

        const { visible, renderModal } = this.state

        return (
            <div>
                {renderModal && 
                <BrandsSelectorModal 
                onCancel={()=>this.setState({ visible: false})}
                afterClose={()=>this.setState({ renderModal: false})}
                visible={visible}/>}
                <Row type="flex"
                    justify="end"
                    style={{
                        marginBottom: 16
                    }}
                >
                    <Button onClick={()=>this.setState({ visible: true, renderModal: true })}>
                        Select Brands
                    </Button>
                </Row>
            </div>
        )
    }

}

export default BrandsSelector


// WEBPACK FOOTER //
// ./src/components/category-feature/editor/brands-selector/index.js